// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"995":"2ab0e101e36d4e5f","2654":"f5f80a3d4f4023d4","2919":"dee66f1ba559145d","8233":"c2870d3a1a9ffd06","8790":"d17c3c62dd724312"}[chunkId] + ".css";
};